import { toast } from 'react-hot-toast';

export const showToast = (message: string) => {
  toast.success(message);
};

export const showWarning = (message: string) => {
  toast(message || 'Something went wrong', { icon: '⚠️' });
};

export const showError = (message: string) => {
  toast.error(message || 'Something went wrong');
};
  